import SharedUtils from "@/utils/sharedUtils";

export default {

    getNormalizedUniqueFileName(filename) {
        return SharedUtils.getTimestamp() + filename.normalize("NFD").replace(/[\u0300-\u036f\s()]/g, "");
    }

}